import { makeStyles } from '@material-ui/styles'
import Theme from '@refera/ui-core'

const summaryLabelBase = {
  fontSize: 13,
  fontWeight: 600,
  textTransform: 'uppercase',
}

export default makeStyles(({ spacing }) => ({
  root: {
    '& .MuiPaper-root': {
      width: `${spacing(1050)} !important`,
      maxWidth: 'none !important',
    },
    '@media (max-width: 1200px)': {
      '& .MuiPaper-root': {
        width: '95vw !important',
      },
    },
  },
  content: {
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    gap: spacing(8),
    minHeight: spacing(50),
    overflowY: 'auto',
    overflowX: 'hidden',
  },
  summaryGrid: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
    gap: spacing(12),
  },
  summaryCard: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(8),
    border: `1px solid ${Theme.Colors.Grayscale.Twelve}`,
    borderRadius: spacing(8),
    padding: spacing(14),
    background: Theme.Colors.Grayscale.White,
  },
  summaryCardPrimary: {
    background: Theme.Colors.Primary.Base,
    borderColor: Theme.Colors.Primary.Base,
    color: '#FFFFFF',
  },
  summaryLabel: {
    ...summaryLabelBase,
    color: Theme.Colors.Grayscale.SixtyFour,
    fontSize: spacing(summaryLabelBase.fontSize),
  },
  summaryValue: {
    color: Theme.Colors.Grayscale.Eighty,
    fontSize: spacing(30),
    fontWeight: 700,
    lineHeight: spacing(34),
  },
  summaryLabelPrimary: {
    ...summaryLabelBase,
    color: '#FFFFFF !important',
    fontSize: spacing(summaryLabelBase.fontSize),
  },
  summaryValuePrimary: {
    color: '#FFFFFF !important',
    fontSize: spacing(30),
    fontWeight: 700,
    lineHeight: spacing(34),
  },
  flagValue: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: spacing(6),
    color: Theme.Colors.Grayscale.Eighty,
    fontSize: spacing(30),
    fontWeight: 700,
    lineHeight: spacing(34),
  },
  dot: {
    width: spacing(10),
    height: spacing(10),
    borderRadius: '50%',
    display: 'inline-flex',
  },
  dotActive: {
    background: Theme.Colors.Green.Base,
  },
  dotInactive: {
    background: Theme.Colors.Grayscale.ThirtyTwo,
  },
  groupsContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(12),
  },
  emptyState: {
    color: Theme.Colors.Grayscale.SixtyFour,
    fontSize: spacing(14),
    fontWeight: 500,
    padding: spacing(8, 0),
  },
  groupCard: {
    width: '100%',
    border: `1px solid ${Theme.Colors.Grayscale.Twelve}`,
    borderRadius: spacing(8),
    background: Theme.Colors.Grayscale.White,
    overflow: 'hidden',
  },
  groupHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: spacing(12, 16),
    borderBottom: `1px solid ${Theme.Colors.Grayscale.Twelve}`,
  },
  groupInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: spacing(8),
    flexWrap: 'wrap',
  },
  groupTitle: {
    color: Theme.Colors.Primary.Base,
    fontSize: spacing(18),
    fontWeight: 700,
  },
  groupMeta: {
    color: Theme.Colors.Grayscale.SixtyFour,
    fontSize: spacing(13),
    fontWeight: 500,
  },
  groupTotal: {
    color: Theme.Colors.Grayscale.Eighty,
    fontSize: spacing(14),
    fontWeight: 700,
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
  },
  tableHeader: {
    display: 'grid',
    gridTemplateColumns: '1.1fr 2fr 0.75fr 0.7fr 0.7fr 0.9fr',
    gap: spacing(10),
    padding: spacing(10, 16),
    color: Theme.Colors.Grayscale.SixtyFour,
    fontSize: spacing(13),
    fontWeight: 700,
    borderBottom: `1px solid ${Theme.Colors.Grayscale.Twelve}`,
  },
  tableRow: {
    display: 'grid',
    gridTemplateColumns: '1.1fr 2fr 0.75fr 0.7fr 0.7fr 0.9fr',
    gap: spacing(10),
    padding: spacing(10, 16),
    color: Theme.Colors.Grayscale.Eighty,
    fontSize: spacing(14),
    fontWeight: 500,
    borderBottom: `1px solid ${Theme.Colors.Grayscale.Four}`,

    '&:last-child': {
      borderBottom: 'none',
    },
  },
  rowValue: {
    color: Theme.Colors.Primary.Base,
    fontWeight: 700,
  },
}))
